import { from } from 'apollo-link';

import authLink from './authLink';
import httpLink from './httpLink';
import onErrorLink from './onErrorLink';

const links = from([onErrorLink, authLink, httpLink]);

export default links;
